var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8412432 13.35l-1.0079799 1-2.0663586-2.05 1.0079798-1c.2116758-.21.5644687-.21.7761445 0l1.2902142 1.28c.2116757.21.2116757.56 0 .77m-9.7774045 5.59l6.1083579-6.06 2.0663586 2.05-6.098278 6.07h-2.0764385v-2.06m0-4.94C6.60856783 14 3 15.79 3 18v2h6.04787904v-1.89l4.03191936-4c-.6652667-.08-1.3406132-.11-2.0159597-.11m0-10C8.83707115 4 7.03191936 5.790861 7.03191936 8s1.80515179 4 4.03191934 4c2.2267676 0 4.0319194-1.790861 4.0319194-4s-1.8051518-4-4.0319194-4z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.ec5a4f1889f6bd83e494b4a72a0d2fba.svg";
export { ForwardRef as ReactComponent };